import { type MouseEvent } from 'react';

/** A pointer click selects the chip without moving focus, so the dock's Enter shortcut still continues. */
export const keepWorkspaceAgentDockFocusOnPointer = (event: MouseEvent<HTMLButtonElement>) => {
  event.preventDefault();
};
